import React, { useState, useEffect } from "react";
import "./Signup.css";
import { Card, Col, Container, Row, Form, Button, Alert, Navbar, Nav, Dropdown } from "react-bootstrap";
import Logo from "../src/Photos/Logo.png";
import { Link, useNavigate } from "react-router-dom";
import container from "../src/Photos/Container.png";
import Account from "../src/Photos/Account.png";

function Signup() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const navigate = useNavigate();

    // State to handle input fields and feedback
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    // Function to handle form submission
    const handleSignup = async (e) => {
        e.preventDefault();
        setMessage(null);
        setError(null);

        try {
            const response = await fetch("https://api-ft5g.onrender.com/signup", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ EmailID: email, Password: password }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage("User registered successfully!");
                setTimeout(() => navigate("/Login"), 2000);
            } else if (response.status === 409) {
                setError(data.message); // email already exists
            } else {
                setError(data.message || "Failed to sign up.");
            }
        } catch (err) {
            console.error(err);
            setError("An error occurred. Please try again.");
        }
    };

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    //   const navigate = useNavigate();

    useEffect(() => {
        // Check if the user is logged in when the component mounts
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");
        setIsLoggedIn(!!(token && userId)); // Set `isLoggedIn` based on the existence of token and userId
    }, []);

    const handleLoginClick = () => {
        if (isLoggedIn) {
            alert("You are already logged in!"); // Show an alert if already logged in
        } else {
            navigate("/Login"); // Redirect to login page if not logged in
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("userId");
        localStorage.removeItem("token");
        localStorage.removeItem("username"); // Remove stored EmailID
        console.log("User logged out and data removed from localStorage.");
        setIsLoggedIn(false);
        navigate("/Login"); // Redirect to login
    };

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <p className="mt-3 logosidetext">Government Recognised Export House</p>
                        </Nav>

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/" className="navtext">Home</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/Aboutus" className="navtext">About Us</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/Products" className="navtext">Shop Now</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/ContactUs" className="navtext">Contact Us</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/ProductCatalogue" className="navtext">Product Catalogue</Nav.Link>
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle
                                    className="scrollbtn2 p-0 mx-3 mt-1 responsiveview"
                                    id="dropdown-basic"
                                >
                                    <img
                                        src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleLoginClick}>Login</Dropdown.Item> {/* Login click handler */}
                                    {isLoggedIn && <Dropdown.Item href="/Profile">My Profile</Dropdown.Item>}
                                    {isLoggedIn && <Dropdown.Item href="/UserDashboard">Dashboard</Dropdown.Item>}
                                    {isLoggedIn && (
                                        <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>

                            {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0 mx-3 responsiveview">
                                <Link to="/Profile">
                                    <img src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Link>
                            </Button> */}

                            <Button onClick={scrollToTop} className="scrollbtn2 p-0 mx-3 responsiveview">
                                <Link to="/Addtocontainer">
                                    <img src={container}
                                        alt="container"
                                        className="d-inline-block align-top"
                                    />
                                </Link>
                            </Button>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle
                            className="scrollbtn2 p-0 me-3 mobileview"
                            id="dropdown-basic"
                        >
                            <img
                                src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleLoginClick}>Login</Dropdown.Item> {/* Login click handler */}
                            {isLoggedIn && <Dropdown.Item href="/Profile">My Profile</Dropdown.Item>}
                            {isLoggedIn && <Dropdown.Item href="/UserDashboard">Dashboard</Dropdown.Item>}
                            {isLoggedIn && (
                                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Button onClick={scrollToTop} className="scrollbtn2 p-0 mobileview">
                        <Link to="/Addtocontainer">
                            <img src={container}
                                alt="container"
                                className="d-inline-block align-top"
                            />
                        </Link>
                    </Button>
                </Container>
            </Navbar>

            {/* ----------------Navbar Complete---------------- */}

            <Container fluid className="backdesign">
                <Row className="justify-content-center">
                    {/* <Col className="p-0" lg={6} md={6}>
                        <Card className="firstcard">
                            <img src={Logo}
                                alt="logo"
                                className="d-inline-block align-top w-50"
                            />
                        </Card>
                    </Col> */}

                    <Col className="p-0 mb-4" lg={6} md={6} xs={12}>
                        <Card className="px-5 py-5 rightcard">
                            <Row>
                                <Col>
                                    <Card className="mt-3 p-5 rightinsidecard">
                                        <Row>
                                            <Col className="text-center mt-4" xs={12}>
                                                <p className="login">Sign Up</p>
                                            </Col>
                                        </Row>

                                        {/* Feedback Messages */}
                                        {message && (
                                            <Alert variant="success" className="text-center">
                                                {message}
                                            </Alert>
                                        )}
                                        {error && (
                                            <Alert variant="danger" className="text-center">
                                                {error}
                                            </Alert>
                                        )}

                                        <Form onSubmit={handleSignup}>
                                            <Row>
                                                <Col xs={12}>
                                                    <Form.Label className="emailid">
                                                        Email ID
                                                    </Form.Label>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs={12}>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="Enter Your Email ID"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className="mt-3">
                                                    <Form.Label className="password">
                                                        Password
                                                    </Form.Label>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col>
                                                    <Form.Control
                                                        type="password"
                                                        placeholder="Enter Your Password"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        required
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className="text-center mt-5">
                                                    <Button
                                                        type="submit"
                                                        className="w-100 loginbtn"
                                                    >
                                                        Sign Up
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>

                                        <Row>
                                            <Col className="text-center mt-4">
                                                <p className="line">Have an Account?
                                                    <Link to="/Login" className="signuplink">Login In</Link>
                                                </p>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Signup;